import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Es seguro?',
    a: '100%. Son movimientos naturales que respetan la anatomía del lactante.'
  }, {
    q: '¿Cuándo veré resultados?',
    a: 'En la mayoría de los casos, el llanto cesa en los primeros 10-15 minutos de aplicación.'
  }, {
    q: '¿Necesito comprar algo más?',
    a: 'No. Solo necesitas tus manos y este manual.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-27">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-28">
        <FadeIn data-id="element-29">
          <div className="text-center mb-16" data-id="element-30">
            <h2 className="text-3xl md:text-4xl font-bold text-earth-darker mb-4" data-id="element-31">
              PREGUNTAS FRECUENTES:
            </h2>
            <div className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-32" />
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-33">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-34">
              <div className="border border-earth-light/50 rounded-2xl overflow-hidden bg-cream/50 transition-colors hover:bg-cream cursor-pointer" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-35">
                <div className="p-6 flex justify-between items-center gap-4" data-id="element-36">
                  <h3 className="text-lg md:text-xl font-bold text-earth-darker" data-id="element-37">
                    {faq.q}
                  </h3>
                  <ChevronDown className={`w-6 h-6 text-accent transition-transform duration-300 flex-shrink-0 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-38" />
                </div>

                <AnimatePresence data-id="element-39">
                  {openIdx === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-40">
                      <div className="px-6 pb-6 text-lg text-earth-dark leading-relaxed" data-id="element-41">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}